import React, { useState, useEffect, useMemo } from 'react';
import DashboardLayout from '../DashboardLayout';
import { useUsers } from '../../metodos/userContext';
import { useConfiguracion } from '../../metodos/ConfiguracionContext';
import logo from '../../assets/logo.png';
import { 
  LayoutDashboard, Calculator, MessageSquare, 
  Settings, LogOut, Menu as MenuIcon, X,
   CalendarDays, Grid3X3, BarChart3, ChevronRight, ChevronDown,
  Users, Receipt, 
   Landmark
} from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../metodos/AuthContext';

const routes = [ 
  { 
    name: "Cotizar", 
    icon: <Calculator size={20} />, 
    path: "/dashboard",
    permission: 'permiso_solicitudes',
    hasSubmenu: true,
    submenu: [
      { name: "Cotizaciones", icon: <Grid3X3 size={16} />, path: "/dashboard",permission: 'permiso_solicitudes'},
      { name: "proPlataforma", icon: <BarChart3 size={16} />, path: "/dashboard/plataforma",permission: 'permisoTesis'},
      { name: "Tesis Manager", icon: <BarChart3 size={16} />, path: "/dashboard/tesis_manager",permission: 'permisoProPlataforma'},
    ]
  },
  { 
    name: "Plataformas", 
    icon: <LayoutDashboard size={20} />,
    path: "/proPlataforma",
    //permission: 'permiso_tutores',
  },
  { 
    name: "Guardador", 
    icon: <LayoutDashboard size={20} />,
    path: "/guardador",
    //permission: 'permiso_tutores',
  },
  { 
    name: "Dashboard", 
    icon: <LayoutDashboard size={20} />,
    path: "/dashdashv2",
    permission: 'permiso_tutores',
  },
  { 
    name: "Recursos Humanos", 
    icon: <Users size={20} />,
    path: "/tutores",
    permission: 'permiso_tutores',
  },
  { 
    name: "Estadisticas", 
    icon: <BarChart3 size={20} />, 
    path: "/estadisticas",
    permission: 'permiso_estadisticasPlataforma',
    hasSubmenu: true,
    submenu: [
      { name: "Estadisticas", icon: <Grid3X3 size={16} />, path: "/estadisticas",permission: 'permiso_estadisticasPlataforma'},
      { name: "Marketing", icon: <BarChart3 size={16} />, path: "/estadisticas/marketing",permission: 'permiso_estadisticasPlataforma'},
    ]
  },
  { 
    name: "Calendario", 
    icon: <CalendarDays size={20} />, 
    path: "/calendario",
    hasSubmenu: false,
    permission: 'permisoCalendario',
  },
  { 
    name: "Clientes", 
    icon: <Users size={20} />, 
    path: "/clientes",
    permission: 'permisoClientes',
  },
  { 
    name: "Contabilidad ", 
    icon: <Landmark size={20} />, 
    path: "/contabilidad/registrar_pagos",
    permission: 'permiso_contabilidad_central',
    hasSubmenu : true,
    submenu: [
      { name: "Pagos", icon: <Grid3X3 size={16} />, path: "/contabilidad/registrar_pagos",permission: 'permiso_contabilidad_central'},
      //{ name: "Servicios", icon: <Grid3X3 size={16} />, path: "/contabilidad",permission: 'permiso_contabilidad_central'},
      { name: "Costos", icon: <Grid3X3 size={16} />, path: "/contabilidad/costos",permission: 'permiso_contabilidad_central'},
    ],
  },
  { 
    name: "Cuentas de cobro", 
    icon: <Receipt size={20} />,  
    path: "/cuentasDeCobro",
    permission: 'permisoCuentaCobro',
  },
  { 
    name: "Configuracion", 
    icon: <Settings size={20} />, 
    path: "/configuracion",
    hasSubmenu: true,
    submenu: [
      { name: "Configuracion", icon: <Grid3X3 size={16} />, path: "/configuracion",permission: 'permiso_configuracionGeneral'},
      { name: "Agregar Variables", icon: <Grid3X3 size={16} />, path: "/configuracion/agregar",permission: 'permiso_configuracionGeneral'},
    ],
    permission: 'permiso_configuracionGeneral',
  },
  { 
    name: "Whatsapp", 
    icon: <MessageSquare size={20} />, 
    path: "/whatsapp/embudo",
    hasSubmenu: true,
    submenu: [
      { name: "Chat", icon: <Grid3X3 size={16} />, path: "/whatsapp"},
      { name: "Embudo", icon: <Grid3X3 size={16} />, path: "/whatsapp/embudo"},
    ],
  }
];

const HomeScreenAdmin = () => {

  const { usuario} = useUsers();
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  //filtrado de rutas
  const filteredRoutes = useMemo(() => {
    //console.log("🚀 Inicia el cálculo de rutas filtradas...");

    // 1. Verifica si existen los datos necesarios
    if (!usuario || !usuario.permisosUsuario) {
      console.warn("🚫 Usuario o permisos no encontrados. Se retorna un arreglo vacío.");
      return [];
    }

    // 2. Muestra los permisos del usuario actual
    const userPermissions = usuario.permisosUsuario;
    //console.log("✅ Permisos del usuario actual:", userPermissions);

    const finalRoutes = routes.map(route => {
      //console.log(`\nProcessing route: ${route.name}`);

      // 3. Filtra los submenús y muestra el proceso
      const visibleSubmenus = route.submenu?.filter(subItem => {
          const requiredPermission = subItem.permission;
          const hasPermission = userPermissions[requiredPermission] === true;
          
          /*
          console.log(
            `-- Submenu: '${subItem.name}' | Permiso: '${requiredPermission}' | Tiene?: ${hasPermission}`
          );
          */
          
          // La condición para mostrarlo es que no requiera permiso o que el usuario lo tenga
          return !requiredPermission || hasPermission;
        }) || [];

      //console.log(`-> Submenús visibles para '${route.name}':`, visibleSubmenus.map(s => s.name));

      // 4. Determina si la ruta principal es visible
      const hasVisibleSubmenus = visibleSubmenus.length > 0;
      const mainPermissionRequired = route.permission;
      const hasMainPermission = !mainPermissionRequired || userPermissions[mainPermissionRequired] === true;

      //console.log(`-> Ruta principal '${route.name}' | Permiso: '${mainPermissionRequired}' | Tiene?: ${hasMainPermission}`);
      //console.log(`-> ¿Se mostrará '${route.name}'?`, hasMainPermission || hasVisibleSubmenus ? "Sí" : "No");
      
      // 5. Devuelve la ruta si cumple las condiciones
      if (hasMainPermission || hasVisibleSubmenus) {
        return { ...route, submenu: visibleSubmenus };
      }
      
      return null;
    }).filter(Boolean); // Filtra los nulos

    // 6. Muestra el resultado final
    console.log("\n✅✅✅ Rutas finales filtradas:", finalRoutes);
    
    return finalRoutes;

  }, [usuario]);
  useEffect(() => {
    // No hagas nada si las rutas aún no se han calculado o no hay ninguna disponible
    if (filteredRoutes.length === 0) {
      return; 
    }

    // 1. Define la ruta de destino: la primera en la lista filtrada
    const firstAvailablePath = filteredRoutes[0].path;

    // 2. Obtén la ruta del primer submenú, si existe
    const firstSubmenuPath = filteredRoutes[0].submenu?.[0]?.path;

    // 3. Elige la ruta del submenú si existe, si no, la del menú principal
    const destinationPath = firstSubmenuPath || firstAvailablePath;

    // 4. Comprueba si el usuario está en la ruta raíz del dashboard ('/dashboard')
    // y si esa ruta de destino es diferente.
    if (location.pathname === '/dashboard' && location.pathname !== destinationPath) {
      console.log(`Redirigiendo de /dashboard a ${destinationPath}`);
      // Redirige al usuario a la primera ruta que tiene disponible
      navigate(destinationPath, { replace: true });
    }

  }, [filteredRoutes, location.pathname, navigate]); // Dependencias del efecto

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <DashboardLayout 
      routes={filteredRoutes} // Pasamos las rutas ya filtradas
      user={usuario}          // Pasamos el usuario para el Topbar
      onLogout={handleLogout} // Pasamos la función de salir
      appTitle="Portal administrador / colaborador"
      customLogo={logo}
    />
  );

}

export default HomeScreenAdmin
